import { TargetGroup } from '@/types/av-check';

export function setSessionTargetGroup(targetGroup: TargetGroup) {
  window.sessionStorage.setItem('sessionTargetGroup', targetGroup);
}

export function getSessionTargetGroup(): TargetGroup | undefined {
  const value = window.sessionStorage.getItem('sessionTargetGroup');
  if (Object.values(TargetGroup).some((tg: string) => tg === value)) {
    return <TargetGroup>value;
  }
  return undefined;
}
